<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-body">
      <canvas width="800" height="250"/>

      <TheValueChartBreakdownModal :user="user" :breakdown="breakdown" :selected-breakdown="selectedBreakdown"/>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import http from '@/http'
import moment from 'moment'
import TheValueChartBreakdownModal from './TheValueChartBreakdownModal'

export default {
  components: {TheValueChartBreakdownModal},

  props: {
    user: {
      required: true,
      type: Object
    },

    from: {
      required: true,
      type: String
    },

    to: {
      required: true,
      type: String
    },

    breakdown: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      data: null,
      selectedBreakdown: null,

      chart: null
    }
  },

  mounted() {
    this.load().then(this.draw)
  },

  watch: {
    from() {
      this.load().then(this.draw)
    },

    to() {
      this.load().then(this.draw)
    },

    breakdown() {
      this.load().then(this.draw)
    }
  },

  computed: {
    dataPromise() {
      const metrics = [
        {name: 'ad_value_after_costs'},
        {name: 'first_partnership_period_value'},
      ]

      if (this.breakdown === 'months') {
        metrics.push({name: 'user_revenue_target'},)
      }

      return http.post('/api/v1/reports/new-analytics', {
        metrics: metrics,
        dimensions: [
          {name: this.breakdown === 'months' ? 'sold_month' : 'sold_week'},
        ],
        filters: [
          {dimension: 'sold_at', operator: '>=', value: this.from},
          {dimension: 'sold_at', operator: '<=', value: this.to},
          {dimension: 'user_id', operator: '=', value: this.user.id}
        ]
      })
    },

    breakdowns() {
      let current = moment(this.from)

      let breakdowns = []

      while (current <= moment(this.to)) {
        breakdowns.push(
            current
                .startOf(this.breakdown === 'months' ? 'month' : 'isoWeek')
                .format(this.breakdown === 'months' ? 'MM/YYYY' : 'WW/YYYY')
        )

        current.add(1, this.breakdown === 'months' ? 'month' : 'week')
      }

      return breakdowns
    },

    datasets() {
      const result = [
        {
          label: 'Ads',
          data: this.breakdowns.map(breakdown => {
            return this.data
                .filter(row => {
                  if (this.breakdown === 'months') {
                    return row.sold_month === breakdown
                  }

                  return row.sold_week === breakdown
                })
                .reduce((sum, row) => sum + row.ad_value_after_costs, 0)
          }),
          backgroundColor: '#16a34a',
          borderColor: '#16a34a',
          fill: false,
          order: 2
        },
        {
          label: 'Partnerships',
          data: this.breakdowns.map(breakdown => {
            return this.data
                .filter(row => {
                  if (this.breakdown === 'months') {
                    return row.sold_month === breakdown
                  }

                  return row.sold_week === breakdown
                })
                .reduce((sum, row) => sum + row.first_partnership_period_value, 0)
          }),
          backgroundColor: '#20aaea',
          borderColor: '#20aaea',
          fill: false,
          order: 3
        },
      ]

      if (this.breakdown === 'months') {
        result.push(
            {
              label: 'Target',
              type: 'line',
              data: this.breakdowns.map(breakdown => {
                return this.data
                    .filter(row => {
                      if (this.breakdown === 'months') {
                        return row.sold_month === breakdown
                      }

                      return row.sold_week === breakdown
                    })
                    .reduce((sum, row) => sum + row.user_revenue_target, 0)
              }),
              backgroundColor: '#8da3a6',
              borderColor: '#8da3a6',
              fill: false,
              order: 1
            }
        )
      }

      return result
    }
  },

  methods: {
    load() {
      return Promise.all([
        this.dataPromise,
      ]).then(responses => {
        this.data = responses[0].data.data
      })
    },


    draw() {
      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
        type: 'bar',

        data: {
          labels: this.breakdowns,
          datasets: this.datasets
        },

        options: {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                callback: label => this.$options.filters.price(label),
                beginAtZero: true
              }
            }]
          },

          legend: {
            position: 'bottom'
          },

          plugins: {
            datalabels: {
              display: false
            }
          },

          tooltips: {
            callbacks: {
              label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + this.$options.filters.price(d.datasets[t.datasetIndex].data[t.index])
            }
          },

          onClick: (event, elements) => {
            if (elements.length) {
              this.selectedBreakdown = this.breakdowns[elements[0]['_index']]

              this.$nextTick(() => $('#value-chart-breakdown-modal').modal('show'))
            }
          }
        }
      })
    }
  }
}
</script>
